import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

import { InMeetingCasesComponent } from './in-meeting-cases/in-meeting-cases';
import { CaseManagementDetailComponent } from './case-management-detail/case-management-detail';
import { NewCaseManagementComponent } from './new-case-management/new-case-management';
import { CasePopoverComponent } from './case-popover/case-popover';
import { CaptureCustomerInquireComponent } from './capture-customer-inquire/capture-customer-inquire';
import { InquirySignatureModalComponent } from './inquiry-signature-modal/inquiry-signature-modal';

// These 6 components are kept NgModule-declared because they are transitively
// reachable via static imports from InMeetingCasesComponent, which is itself
// anchored in main.js by 5 eager consumers. Making any of them standalone with
// imports:[SharedModule] causes a TDZ circular-init crash at runtime.
//
// Static import chain from InMeetingCasesComponent:
//   InMeetingCasesComponent → CaseManagementDetailComponent → CasePopoverComponent
//                                                            → CaptureCustomerInquireComponent → InquirySignatureModalComponent
//   InMeetingCasesComponent → NewCaseManagementComponent
//
// CaseListItemComponent, CaseManagementListComponent, and CaseManagementHomePage
// are standalone — they are NOT in this static import chain.
@NgModule({
  imports: [SharedModule],
  declarations: [
    InMeetingCasesComponent,
    CaseManagementDetailComponent,
    NewCaseManagementComponent,
    CasePopoverComponent,
    CaptureCustomerInquireComponent,
    InquirySignatureModalComponent,
  ],
  exports: [
    InMeetingCasesComponent,
    CaseManagementDetailComponent,
    NewCaseManagementComponent,
    CasePopoverComponent,
    CaptureCustomerInquireComponent,
    InquirySignatureModalComponent,
  ],
})
export class CaseManagementModule {}
